<template>
<v-sheet color="grey-lighten-4" class="pa-2">
  <ControlUnit
    title="Settings for multi Channel Launcher"
    tooltip="You can set Titile for button and fill in the links for messengers, if leave empty they will be hide"
  >
  
    <div class="input-input">
      <label class="input-input__unit">
        <span class="input-input__label">Set Title:</span>
        <input
          class="input-input__input"
          type="text"
          name="multi-channel-title"
          v-model="currentMultiChannelTitle"
        >
      </label>
    </div>

    <div class="input-input">
      <label class="input-input__unit">
        <span class="input-input__label">Viber:</span>
        <input
          class="input-input__input"
          type="text"
          name="viber-url"
          v-model="currentViberUrl"
          placeholder="viber://"
        >
      </label>
    </div>

    <div class="input-input">
      <label class="input-input__unit">
        <span class="input-input__label">Telegram:</span>
        <input
          class="input-input__input"
          type="text"
          name="telegram-url"
          v-model="currentTelegramUrl"
          placeholder="https://t.me/"
        >
      </label>
    </div>

    <div class="input-input">
      <label class="input-input__unit">
        <span class="input-input__label">Facebook:</span>
        <input
          class="input-input__input"
          type="text"
          name="facebook-url"
          v-model="currentFacebookUrl"
          placeholder="http://m.me/"
        >
      </label>
    </div>

    <div class="input-input">
      <label class="input-input__unit">
        <span class="input-input__label">Whatsapp:</span>
        <input
          class="input-input__input"
          type="text"
          name="whatsapp-url"
          v-model="currentWhatsappUrl"
          placeholder="https://wa.me/"
        >
      </label>
    </div>

    <div class="input-input">
      <label class="input-input__unit">
        <span class="input-input__label">Instagram:</span>
        <input
          class="input-input__input"
          type="text"
          name="instagram-url"
          v-model="currentInstagramUrl"
          placeholder="https://ig.me/m/"
        >
      </label>
    </div>
  
  
  </ControlUnit>
</v-sheet>
</template>


<script>
import useStateController from './useStateController';
import ControlUnit from "@/views/Control/ControlPanel/ControlUnit/ControlUnit";
import {useStore} from "vuex";
import {computed, onMounted} from "vue";
import useRouteController from "@/views/Control/ControlPanel/ControlUnit/useRouteController";
import {runAllWithData} from "@/helpers/functional";

export default ({
  components: {
    ControlUnit,
  },
  setup() {
    const multiChannelTitle = 'multi-channel-title';
    const viberUrl = 'viber-url';
    const telegramUrl = 'telegram-url';
    const facebookUrl = 'facebook-url';
    const whatsappUrl = 'whatsapp-url';
    const instagramUrl = 'instagram-url';
    const store = useStore();

    const currentMultiChannelTitle = computed({
      get() {
        // console.log(store.state.control.multi_channel.button_title, 'store.state.control.multi_channel.button_title')
        return store.state.control.multi_channel.button_title;
      }, set(val){
        changeHandler({
          type: multiChannelTitle,
          value: val,
        })
      }
    });

    const currentViberUrl = computed({
      get() {
        return store.state.control.multi_channel.messengers.viber;
      }, set(val){
        changeHandler({
          type: viberUrl,
          value: val,
        })
      }
    });

    const currentTelegramUrl = computed({
      get() {
        return store.state.control.multi_channel.messengers.telegram;
      }, set(val){
        changeHandler({
          type: telegramUrl,
          value: val,
        })
      }
    });

    const currentFacebookUrl = computed({
      get() {
        return store.state.control.multi_channel.messengers.facebook;
      }, set(val){
        changeHandler({
          type: facebookUrl,
          value: val,
        })
      }
    });

    const currentWhatsappUrl = computed({
      get() {
        return store.state.control.multi_channel.messengers.whatsapp;
      }, set(val){
        changeHandler({
          type: whatsappUrl,
          value: val,
        })
      }
    });

    const currentInstagramUrl = computed({
      get() {
        return store.state.control.multi_channel.messengers.instagram;
      }, set(val){
        changeHandler({
          type: instagramUrl,
          value: val,
        })
      }
    });

    const { changeControlHandler } = useStateController();
    const { setRouteTypeValue, getRouterQueryValue } = useRouteController('Control');

    const changeHandler = runAllWithData(
      changeControlHandler,
      setRouteTypeValue
    );

    onMounted(() => {
      changeControlHandler({
        type: multiChannelTitle,
        value: getRouterQueryValue(multiChannelTitle),
      });

      changeControlHandler({
        type: viberUrl,
        value: getRouterQueryValue(viberUrl),
      });

      changeControlHandler({
        type: telegramUrl,
        value: getRouterQueryValue(telegramUrl),
      });

      changeControlHandler({
        type: facebookUrl,
        value: getRouterQueryValue(facebookUrl),
      });

      changeControlHandler({
        type: whatsappUrl,
        value: getRouterQueryValue(whatsappUrl),
      });

      changeControlHandler({
        type: instagramUrl,
        value: getRouterQueryValue(instagramUrl),
      });
    });
      
    return {
      multiChannelTitle,
      currentMultiChannelTitle,
      currentViberUrl,
      viberUrl,
      currentTelegramUrl,
      telegramUrl,
      currentFacebookUrl,
      facebookUrl,
      currentWhatsappUrl,
      whatsappUrl,
      currentInstagramUrl,
      instagramUrl,
      changeHandler,
    };
  },
})
</script>


